module.exports = __webpack_public_path__ + "img/d.d24a71ba.jpg";